import FlexPane from './_flex-pane.js'
import Text from './_text.js'
import ChangedValueIndicator from './_changed-value-indicator.js'

export default {
  name: 'FormattedLabelWithTotalOdds',
  values: {
    container: {
      configSet: FlexPane,
      configValues: {
        style: {
          padding: '4px 0 0 0',
          alignItems: 'center',
          flexWrap: 'wrap',
        },
      },
    },
    label: {
      configSet: Text,
      configValues: {
        container: {
          flexGrow: 0,
          padding: '0 4px 0 0',
        },
      },
    },
    value: {
      configSet: Text,
      configValues: {
        container: {
          flexGrow: 0,
        },
      },
    },
    priceBoostIndicator: {
      configSet: ChangedValueIndicator,
      configValues: {
        container: {
          style: {
            alignItems: 'center',
          },
        },
        indicationIcon: {
          src: 'double-arrow-right',
          style: {
            minWidth: '12px',
            minHeight: '12px',
          },
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
